module.exports = __webpack_public_path__ + "img/public_filetype_vedio_normal.16de3985.svg";